import { LOGO_SMALL } from '@/assets/logo';
import { ArrowUpRight } from 'lucide-react';

const footerLinks = {
  Services: [
    { label: 'Paid Advertising', href: '#services' },
    { label: 'Lead Generation', href: '#services' },
    { label: 'Funnel Design', href: '#services' },
    { label: 'Conversion Optimization', href: '#services' },
    { label: 'Growth Consulting', href: '#services' },
  ],
  Company: [
    { label: 'About Us', href: '#why-us' },
    { label: 'Case Studies', href: '#results' },
    { label: 'Process', href: '#process' },
    { label: 'Testimonials', href: '#testimonials' },
  ],
  Connect: [
    { label: 'Book a Call', href: '#cta' },
    { label: 'info@vertexmarketing-solutions.com', href: 'mailto:info@vertexmarketing-solutions.com' },
    { label: 'LinkedIn', href: '#', external: true },
    { label: 'Twitter / X', href: '#', external: true },
  ],
};

export default function Footer() {
  const handleClick = (e, href) => {
    if (href.startsWith('#')) {
      e.preventDefault();
      const el = document.querySelector(href);
      if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  return (
    <footer data-testid="footer" className="bg-vertex-950 relative overflow-hidden">
      <div className="absolute top-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-vertex-500/20 to-transparent" />

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-16 pb-8">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-12 mb-16">
          {/* Brand Column */}
          <div className="lg:col-span-2">
            <div className="flex items-center gap-3 mb-5">
              <img
                src={LOGO_SMALL}
                alt="Vertex Marketing Solutions"
                className="h-10 w-10 rounded-lg"
              />
              <div>
                <span className="text-white font-display font-bold text-lg tracking-tight">VERTEX</span>
                <span className="text-vertex-400 font-display font-medium text-xs block -mt-1 tracking-widest">MARKETING SOLUTIONS</span>
              </div>
            </div>
            <p className="text-gray-400 text-sm leading-relaxed max-w-sm mb-6">
              Premium performance marketing for businesses that refuse to settle for average growth. We build scalable acquisition systems powered by data, strategy, and relentless execution.
            </p>
            <div className="flex items-center gap-2 text-gray-500 text-xs">
              <div className="w-2 h-2 rounded-full bg-emerald-500" />
              Currently accepting new clients
            </div>
          </div>

          {/* Link Columns */}
          {Object.entries(footerLinks).map(([category, links]) => (
            <div key={category}>
              <h4 className="text-white font-display font-semibold text-sm mb-5 tracking-wide">{category}</h4>
              <ul className="space-y-3">
                {links.map((link) => (
                  <li key={link.label}>
                    <a
                      href={link.href}
                      onClick={(e) => handleClick(e, link.href)}
                      className="text-gray-400 hover:text-vertex-400 text-sm transition-colors duration-300 inline-flex items-center gap-1 group"
                    >
                      {link.label}
                      {link.external && <ArrowUpRight className="w-3 h-3 opacity-0 group-hover:opacity-100 transition-opacity" />}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-white/5 pt-8 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-gray-500 text-xs">
            &copy; {new Date().getFullYear()} Vertex Marketing Solutions. All rights reserved.
          </p>
          <div className="flex items-center gap-6">
            <a href="#" className="text-gray-500 hover:text-gray-400 text-xs transition-colors">Privacy Policy</a>
            <a href="#" className="text-gray-500 hover:text-gray-400 text-xs transition-colors">Terms of Service</a>
          </div>
        </div>
      </div>
    </footer>
  );
}
